import React, { useContext } from 'react';

import { SET_FILTERS } from './constants';

const ScreenContext = React.createContext({
  screenState: {},
  name: '',
  title: '',
  dispatch: (payload) => {},
});

export const ScreenConsumer = ScreenContext.Consumer;

const FiltersConsumer = ({ children }) => {
  const { screenState, name, title, dispatch } = useContext(ScreenContext);
  const handleSetFilters = (filters) => {
    dispatch({
      type: SET_FILTERS,
      payload: filters,
    });
  };

  return children({
    values: screenState.filters,
    onApply: handleSetFilters,
    screen: name,
    title,
  });
};

ScreenConsumer.Filters = FiltersConsumer;
const FiltersCollectionConsumer = ({ children }) => {
  const { screenState, name, title, dispatch } = useContext(ScreenContext);
  const handleSetFilters = (filtersCollection) => {
    dispatch({
      type: SET_FILTERS,
      payload: filtersCollection,
    });
  };

  return children({
    values: screenState.filtersCollection,
    onApply: handleSetFilters,
    screen: name,
    title,
  });
};

ScreenConsumer.FiltersCollection = FiltersCollectionConsumer;

export default ScreenContext;
